import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { fetchSimoExpiryOptions } from 'api';
import { sortSimoExpiryTypes } from 'helpers/subs';

const withSimoExpiryTypes = (DecoratedComponent) => {
  class WithSimoExpiryTypes extends Component {
    state = {
      simoExpiryTypeOptions: [],
    };

    componentDidMount() {
      this.loadOptions();
    }

    loadOptions = () => {
      fetchSimoExpiryOptions(this.props.subId)
        .then((res) => {
          const choices = res.data && res.data.actions.POST.expiry_type.choices;
          let simoExpiryTypeOptions = choices.map(({ value, display_name }) => [
            value,
            display_name,
          ]);
          simoExpiryTypeOptions = sortSimoExpiryTypes(simoExpiryTypeOptions);
          this.setState({ simoExpiryTypeOptions });
        })
        .catch((e) => {
          toast.error('Failed to load expiry choices');
        });
    };

    render() {
      const { children, ...props } = this.props;
      const { simoExpiryTypeOptions } = this.state;
      const childProps = {
        simoExpiryTypeOptions,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  return WithSimoExpiryTypes;
};

export default withSimoExpiryTypes;
